
/*eslint-disable*/
import React from "react";
// react library for routing
// reactstrap components
import {
    Button,
    FormGroup,
    Input,
    Form,
    InputGroupAddon,
    InputGroupText,
    InputGroup,
} from "reactstrap";
// core components
import { IndexNavbar } from "components/Navbars/IndexNavbar.jsx";
// import AuthNavbar from "components/Navbars/AuthNavbar.jsx";

import { FeaturedCelebsSection, FeaturedEventsSection, Accordion } from "components";
import { PulseLoader } from 'react-spinners';

import FacebookLogin from 'react-facebook-login/dist/facebook-login-render-props'
import GoogleLogin from 'react-google-login';
import AppleSignIn from "components/AppleSignIn/AppleSignIn.jsx";
// import { Redirect } from "react-router-dom";
import { config } from '_constants';
import { isProductionBuild } from "_helpers";

export default function AuthFormContainer(props) {
    const {
        is_xs,
        activeContainer,
        setActiveContainer,
        signupEmailFocus,
        signinEmailFocus,
        signinPasswordFocus,
        email,
        username,
        password,
        handleChange,
        enterPressed,
        startEmailRegistration,
        forgotPasswordAlert,
        handleSubmit,
        responseFacebook,
        responseGoogle,
        responseApple,
        tryAppleLogIn,
        setSigninEmailFocus,
        setSignupEmailFocus,
        setSigninPasswordFocus
    } = props;
    const [showPassword, setShowPassword] = React.useState(false);
    return (
        <div className="auth-form-container">
            {/* SIGN UP */}
            <div
                className="form-container sign-up-container"
                style={
                    is_xs && activeContainer === "right-panel-active"
                        ? { width: "100%", transform: "translateX(0%)" }
                        : is_xs && activeContainer === ""
                            ? { width: "0%", display: "none" }
                            : {}
                }
            >
                <Form role="form" onSubmit={(e) => e.preventDefault()}>
                    <h1 className="livenyte-title text-primary" style={{ fontSize: "2rem" }}>
                        LiveNyte
                    </h1>
                    <h3 className="surtitle">Sign up</h3>
                    <div className="my-2 special-underline-lightGray" />

                    {/* SOCIAL */}
                    <div className="social-container">
                        <FacebookLogin
                            appId="197943750696053"
                            autoLoad={false}
                            fields="name,email,picture"
                            scope="public_profile"
                            redirectUri={config.serverUrl}
                            isMobile={false}
                            disableMobileRedirect={true}
                            callback={responseFacebook}
                            render={(renderProps) => (
                                <Button color="facebook" style={{ width: "35px", height: "35px", fontSize: "1.1rem" }} size="sm" type="button" onClick={renderProps.onClick} >
                                    <span className="btn-inner--icon">
                                        <i className="fa-brands fa-facebook" style={{ top: "-3px", verticalAlign: "middle" }}></i>
                                    </span>
                                </Button>
                            )}
                        />

                        <GoogleLogin
                            clientId="1007593483972-gr74opa14suioe6bkvp0etop08pbfjoj.apps.googleusercontent.com"
                            onSuccess={(rsp) => responseGoogle(true, rsp)}
                            onFailure={(rsp) => responseGoogle(false, rsp)}
                            redirectUri={config.serverUrl}
                            cookiePolicy="single_host_origin"
                            render={(renderProps) => (
                                <Button color="white" size="sm" style={{ width: "35px", height: "35px" }} type="button" className="" onClick={renderProps.onClick}>
                                    {/* <span className="btn-inner--icon" >
                                  <i className="fa-brands fa-google" style={{top:"1px"}}></i>
                              </span> */}
                                    <span className="btn-inner--icon">
                                        <img
                                            alt="Google"
                                            style={{ width: "17px", height: "17px" }}

                                            src={require("assets/img/icons/common/google.svg").default}
                                        />
                                    </span>
                                </Button>
                            )}
                        />

                        {isProductionBuild() && (
                            <AppleSignIn
                                config={{
                                    clientId: "com.livenyte.livenyte",
                                    redirectURI: config.serverUrl,
                                    responseType: "code",
                                    responseMode: "form_post",
                                    scope: "name email",
                                    usePopup: true,
                                }}
                                onSuccess={(rsp) => responseApple(true, rsp)}
                                onFailure={(rsp) => responseApple(false, rsp)}
                                render={(renderProps) => (
                                    <Button color="dark" size="sm" type="button" style={{ width: "35px", height: "35px" }} onClick={renderProps.onClick}>
                                        <span className="btn-inner--icon">
                                            <i className="fa-brands fa-apple" style={{ fontSize: "1.15rem", top: "0.1rem", left: "0.02rem" }}></i>
                                        </span>
                                    </Button>
                                )}
                            />
                        )}
                    </div>

                    <span className="h5 mb-4 pt-2 surtitle text-default" style={{ fontWeight: 400 }}>
                        or with email
                    </span>

                    <FormGroup className={`mb-3 ${signupEmailFocus}`} style={{ maxWidth: 300 }}>
                        <InputGroup className="input-group-alternative">
                            <InputGroupAddon addonType="prepend">
                                <InputGroupText>
                                    <i className="ni ni-email-83"></i>
                                </InputGroupText>
                            </InputGroupAddon>
                            <Input
                                placeholder="Email"
                                type="email"
                                name="email"
                                value={email}
                                onChange={handleChange}
                                onKeyPress={enterPressed}
                                onFocus={() => setSignupEmailFocus("focused")}
                                onBlur={() => setSignupEmailFocus("")}
                            />
                        </InputGroup>
                    </FormGroup>

                    <Button
                        color="primary"
                        className="mt-3 bg-gradient-livenyte"
                        onClick={startEmailRegistration}
                    >
                        Sign Up
                    </Button>

                    {is_xs && (
                        <span className="h4 mt-4 pt-2">
                            Already have an account?
                            <Button
                                color="primary"
                                id="signIn"
                                size="sm"
                                outline
                                className="ml-2"
                                onClick={() => setActiveContainer("")}
                            >
                                Sign In
                            </Button>
                        </span>
                    )}
                </Form>
            </div>

            {/* SIGN IN */}
            <div
                className="form-container sign-in-container"
                style={
                    is_xs && activeContainer === "right-panel-active"
                        ? { width: "0%", display: "none" }
                        : is_xs && activeContainer === ""
                            ? { width: "100%" }
                            : {}
                }
            >
                <Form role="form" onSubmit={(e) => e.preventDefault()}>
                    <h1 className="livenyte-title text-primary" style={{ fontSize: "2rem" }}>
                        LiveNyte
                    </h1>
                    <h3 className="surtitle">Sign In</h3>
                    <div className="my-2 special-underline-lightGray" />

                    {/* SOCIAL */}
                    <div className="social-container">
                        <FacebookLogin
                            appId="197943750696053"
                            autoLoad={false}
                            fields="name,email,picture"
                            scope="public_profile"
                            isMobile={false}
                            disableMobileRedirect={true}
                            redirectUri={config.serverUrl}
                            callback={responseFacebook}
                            render={(renderProps) => (
                                <Button color="facebook" style={{ width: "35px", height: "35px", fontSize: "1.1rem" }} size="sm" type="button" onClick={renderProps.onClick} >
                                    <span className="btn-inner--icon">
                                        <i className="fa-brands fa-facebook" style={{ top: "-3px", verticalAlign: "middle" }}></i>
                                    </span>
                                </Button>
                            )}
                        />

                        <GoogleLogin
                            clientId="1007593483972-gr74opa14suioe6bkvp0etop08pbfjoj.apps.googleusercontent.com"
                            onSuccess={(rsp) => responseGoogle(true, rsp)}
                            onFailure={(rsp) => responseGoogle(false, rsp)}
                            redirectUri={config.serverUrl}
                            cookiePolicy="single_host_origin"
                            render={(renderProps) => (
                                <Button color="white" size="sm" style={{ width: "35px", height: "35px" }} type="button" className="" onClick={renderProps.onClick}>
                                    {/* <span className="btn-inner--icon" >
                                  <i className="fa-brands fa-google" style={{top:"1px"}}></i>
                                </span> */}
                                    <span className="btn-inner--icon">
                                        <img
                                            alt="Google"
                                            style={{ width: "17px", height: "17px" }}
                                            src={require("assets/img/icons/common/google.svg").default}
                                        />
                                    </span>
                                </Button>
                            )}
                        />

                        {isProductionBuild() && (
                            <Button color="dark" size="sm" type="button" style={{ width: "35px", height: "35px" }} onClick={tryAppleLogIn}>
                                <span className="btn-inner--icon">
                                    <i className="fa-brands fa-apple" style={{ fontSize: "1.15rem", top: "0.1rem", left: "0.02rem" }}></i>
                                </span>
                            </Button>
                        )}
                    </div>

                    <span className="text-default h5 pt-2 mb-4 surtitle" style={{ fontWeight: 400 }}>
                        or with email + password
                    </span>

                    <FormGroup className={`mb-3 ${signinEmailFocus}`} style={{ maxWidth: 300 }}>
                        <InputGroup className="input-group-alternative">
                            <InputGroupAddon addonType="prepend">
                                <InputGroupText>
                                    <i className="ni ni-email-83"></i>
                                </InputGroupText>
                            </InputGroupAddon>
                            <Input
                                placeholder="Email"
                                type="email"
                                name="username"
                                autoComplete="username"
                                value={username}
                                onChange={handleChange}
                                onFocus={() => setSigninEmailFocus("focused")}
                                onBlur={() => setSigninEmailFocus("")}
                            />
                        </InputGroup>
                    </FormGroup>

                    <FormGroup className={signinPasswordFocus} style={{ maxWidth: 300 }}>
                        <InputGroup className="input-group-alternative">
                            <InputGroupAddon addonType="prepend">
                                <InputGroupText>
                                    <i className="ni ni-lock-circle-open"></i>
                                </InputGroupText>
                            </InputGroupAddon>
                            <Input
                                placeholder="Password"
                                type={showPassword ? "text" : "password"}
                                name="password"
                                autoComplete="current-password"
                                value={password}
                                onChange={handleChange}
                                onKeyPress={enterPressed}
                                onFocus={() => setSigninPasswordFocus("focused")}
                                onBlur={() => setSigninPasswordFocus("")}
                            />
                            {/* RIGHT “EYE” ICON */}
                            <InputGroupAddon addonType="append">
                                <InputGroupText
                                    style={{ cursor: "pointer" }}
                                    onClick={() => setShowPassword(!showPassword)}
                                >
                                    {showPassword ? (
                                        <i className="fa-regular fa-eye-slash"></i>
                                    ) : (
                                        <i className="fa-regular fa-eye"></i>
                                    )}
                                </InputGroupText>
                            </InputGroupAddon>
                        </InputGroup>

                    </FormGroup>

                    <Button
                        color="primary"
                        className="mt-2 bg-gradient-livenyte"
                        onClick={handleSubmit}
                    >
                        Sign In
                    </Button>

                    <p className="text-underline cursor-pointer" onClick={forgotPasswordAlert}>
                        Forgot your password?
                    </p>

                    {is_xs && (
                        <span className="h4">
                            Don't have an account?
                            <Button
                                color="primary"
                                size="sm"
                                outline
                                className="ml-2"
                                onClick={() => setActiveContainer("right-panel-active")}
                            >
                                Sign Up
                            </Button>
                        </span>
                    )}
                </Form>
            </div>

            {/* OVERLAY (desktop only) */}
            {!is_xs && (
                <div className="overlay-container">
                    <div className="overlay">
                        <div className="overlay-panel overlay-left">
                            <h1 className="text-white">Welcome back!</h1>
                            <p>To get back into your LiveNyte account, please login here.</p>
                            <Button
                                className="btn-neutral"
                                color="default"
                                id="signIn"
                                size="sm"
                                onClick={() => setActiveContainer("")}
                            >
                                Sign In
                            </Button>
                        </div>

                        <div className="overlay-panel overlay-right">
                            <h1 className="text-white">Hey there!</h1>
                            <p>We're excited to start this journey with you!</p>
                            <Button
                                className="btn-neutral"
                                color="default"
                                size="sm"
                                onClick={() => setActiveContainer("right-panel-active")}
                            >
                                Sign Up
                            </Button>
                        </div>
                    </div>
                </div>
            )}
        </div>
    );
}